import React from "react";

import { Fade } from "react-reveal";

import {
  ContactUsSVG,
  GetInstructionSVG,
  StaySafeSVG,
} from "../../../../assets/svgs";
import { Button } from "../../../../components";

import "./styles.css";

const NextSteps = () => {
  return (
    <Fade bottom>
      <section className="rural_next_steps_container">
        <div className="rural_next_steps_inner">
          <div className="rural_next_steps_intro">
            <span className="h2-sb text-primary">Next steps</span>
            <h1 className="h1-b text-white">
              Map See It Send It to your government program
            </h1>
            <p className="h3-m text-white">
              We can help align workflows to your service model, grant goals,
              partner visibility, and safety needs.
            </p>
          </div>
          <div className="rural_next_steps_actions">
            <div className="rural_next_step">
              <div className="rural_next_step_icon">
                <ContactUsSVG />
              </div>
              <p className="h2-m text-white">Contact us</p>
            </div>
            <div className="rural_next_step">
              <div className="rural_next_step_icon">
                <GetInstructionSVG />
              </div>
              <p className="h2-m text-white">Map workflows to your model</p>
            </div>
            <div className="rural_next_step">
              <div className="rural_next_step_icon">
                <StaySafeSVG />
              </div>
              <p className="h2-m text-white">Support outreach and response</p>
            </div>
          </div>
          <Button
            label="CONTACT US"
            link="/contact"
            color="black"
            styles="rural_contact_button"
          />
        </div>
      </section>
    </Fade>
  );
};

export default NextSteps;
